import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ScrollFloat from './ScrollFloat';
import './CTA.css';

const CTA = () => {
  const navigate = useNavigate();
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  
  return (
    <section id="cta" className="cta">
      <div ref={sectionRef} className={`cta-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="cta-content">
          <h2 className="cta-title">
            <ScrollFloat speed={0.3} direction="up">Ready to Transform Your Company's Knowledge Access?</ScrollFloat>
          </h2>
          <p className="cta-subtitle">
            <ScrollFloat speed={0.2} direction="up">
              Join forward-thinking companies that are eliminating information gaps and 
              empowering their teams with instant access to knowledge.
            </ScrollFloat>
          </p>
          <div className="cta-buttons">
            <button 
              className="cta-btn-primary"
              onClick={() => navigate('/contact')}
              aria-label="Schedule a demo to transform your company's knowledge access"
            >
              Schedule a Demo
            </button>
          </div>
          <div className="cta-features">
            <div className="cta-feature">
              <span className="check-icon"></span>
              <span>Free 14-day trial</span>
            </div>
            <div className="cta-feature">
              <span className="check-icon"></span>
              <span>No credit card required</span>
            </div>
            <div className="cta-feature">
              <span className="check-icon"></span>
              <span>Setup in minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;

